import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Applied jobs",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  th: createLanguage({
    "Job search": "ค้นหางาน",
    "People search": "ค้นหาโปรไฟล์",
    Profile: "โปรไฟล์",
    "Career advice": "ครบเครื่องเรื่องงาน",
    "Saved searches": "บันทึกการค้นหา",
    "Saved jobs": "งานที่บันทึก",
    "Applied jobs": "ประวัติการสมัครงาน",
    "Employer site": "ผู้ประกอบการเข้าสู่ระบบ",
    Volunteering: "อาสาสมัคร",
    Companies: "บริษัท",
    Community: "ชุมชน",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  id: createLanguage({
    "Job search": "Cari lowongan",
    "People search": "Cari profil",
    Profile: "Lihat profil",
    "Career advice": "Sumber daya karir",
    "Saved searches": "Pencarian tersimpan",
    "Saved jobs": "Lowongan tersimpan",
    "Applied jobs": "Lamaran kerja",
    "Employer site": "Untuk perusahaan",
    Volunteering: "Pekerjaan sukarela",
    Companies: "Perusahaan",
    Community: "Komunitas",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  zh: createLanguage({
    "Job search": "搜尋職位",
    "People search": "搜尋用戶",
    Profile: "個人檔案",
    "Career advice": "就業建議",
    "Saved searches": "已儲存搜尋",
    "Saved jobs": "已儲存職位",
    "Applied jobs": "已申請職位",
    "Employer site": "僱主平台",
    Volunteering: "義工服務專頁",
    Companies: "公司",
    Community: "打工仔交流區",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-AU": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Applied jobs",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-HK": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Application history",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-ID": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Job applications",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-MY": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Job applications",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-NZ": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Applied jobs",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-PH": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Job applications",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-SG": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Job applications",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-TH": createLanguage({
    "Job search": "Job search",
    "People search": "People search",
    Profile: "Profile",
    "Career advice": "Career advice",
    "Saved searches": "Saved searches",
    "Saved jobs": "Saved jobs",
    "Applied jobs": "Application history",
    "Employer site": "Employer site",
    Volunteering: "Volunteering",
    Companies: "Companies",
    Community: "Community",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "th-TH": createLanguage({
    "Job search": "ค้นหางาน",
    "People search": "ค้นหาโปรไฟล์",
    Profile: "โปรไฟล์",
    "Career advice": "ครบเครื่องเรื่องงาน",
    "Saved searches": "บันทึกการค้นหา",
    "Saved jobs": "งานที่บันทึก",
    "Applied jobs": "ประวัติการสมัครงาน",
    "Employer site": "ผู้ประกอบการเข้าสู่ระบบ",
    Volunteering: "อาสาสมัคร",
    Companies: "บริษัท",
    Community: "ชุมชน",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "id-ID": createLanguage({
    "Job search": "Cari lowongan",
    "People search": "Cari profil",
    Profile: "Lihat profil",
    "Career advice": "Sumber daya karir",
    "Saved searches": "Pencarian tersimpan",
    "Saved jobs": "Lowongan tersimpan",
    "Applied jobs": "Lamaran kerja",
    "Employer site": "Untuk perusahaan",
    Volunteering: "Pekerjaan sukarela",
    Companies: "Perusahaan",
    Community: "Komunitas",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "zh-HK": createLanguage({
    "Job search": "搜尋職位",
    "People search": "搜尋用戶",
    Profile: "個人檔案",
    "Career advice": "就業建議",
    "Saved searches": "已儲存搜尋",
    "Saved jobs": "已儲存職位",
    "Applied jobs": "已申請職位",
    "Employer site": "僱主平台",
    Volunteering: "義工服務專頁",
    Companies: "公司",
    Community: "打工仔交流區",
    Business: "Business",
    Recruiters: "Recruiters"
  }),
  "en-PSEUDO": createLanguage({
    "Job search": "[Ĵöööß šẽẽẽăăăřçḩ]",
    "People search": "[Ƥẽẽẽöööƥƚẽẽẽ šẽẽẽăăăřçḩ]",
    Profile: "[Ƥřööƒììƚẽẽ]",
    "Career advice": "[Çăăřẽẽẽẽř ăăƌṽììçẽẽ]",
    "Saved searches": "[Šăăăṽẽẽẽƌ šẽẽẽăăăřçḩẽẽẽš]",
    "Saved jobs": "[Šăăăṽẽẽẽƌ ĵööößš]",
    "Applied jobs": "[Ậƥƥƚìììẽẽẽƌ ĵööößš]",
    "Employer site": "[Ëm̂ƥƚöööýýýẽẽẽř šìììṯẽẽẽ]",
    Volunteering: "[Ṽööƚǚǚกี้ṯẽẽẽẽřììกี้ģ]",
    Companies: "[Çööm̂ƥăăกี้ììẽẽš]",
    Community: "[Çööm̂m̂ǚǚกี้ììṯýý]",
    Business: "[ẞǚǚǚšìììกี้ẽẽẽšš]",
    Recruiters: "[Řẽẽçřǚǚììṯẽẽřš]"
  })
});
export {
  translations
};
